/**
 * 탈퇴 후 보관·익명 처리 개정(2026-10) 날짜 — 이용약관 제10조 제2항, 개인정보처리방침 제3조, 강사 정산 계좌 동의가 함께 쓴다.
 * 게시일 = 시행일 = 사용자 웹 배포일 — 사용자 결정(2026-10-10)으로 사전 공지 없이 배포일에 바로 시행.
 * **배포일이 바뀌면 [WITHDRAWAL_RETENTION_EFFECTIVE_ISO] 한 값만 고친다**(README 배포 전 필수 체크 6). 게시일과 약관·방침·강사 약관 버전이 따라간다.
 * 탈퇴 창·로그인 복구 창 문구는 실제 동작 안내라 시행일과 무관하게 바로 적용된다.
 */
export const WITHDRAWAL_RETENTION_EFFECTIVE_ISO = '2026-10-11';
/** 게시일 — 시행일과 같은 날 */
export const WITHDRAWAL_RETENTION_NOTICE_ISO: string = WITHDRAWAL_RETENTION_EFFECTIVE_ISO;

/** '2026-10-10' → '2026년 10월 10일' */
export const toKoreanDate = (iso: string): string => {
    const [year, month, day] = iso.split('-').map((part: string) => Number(part));
    return `${year}년 ${month}월 ${day}일`;
};

export const WITHDRAWAL_RETENTION_NOTICE_DATE: string = toKoreanDate(WITHDRAWAL_RETENTION_NOTICE_ISO);
export const WITHDRAWAL_RETENTION_EFFECTIVE_DATE: string = toKoreanDate(WITHDRAWAL_RETENTION_EFFECTIVE_ISO);
